<template>
  <hm-content title="">
    <div class="">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item label="文本名称" prop="popoverName">
          <el-input
            style="width:300px"
            v-model.trim="ruleForm.popoverName"
            maxlength="20"
            size="small"
            clearable
            placeholder="请输入单行文本，限制40个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="文本编码" prop="popoverCode">
          <el-input
            style="width:300px"
            v-model.trim="ruleForm.popoverCode"
            maxlength="40"
            size="small"
            clearable
            placeholder="请输入单行文本，限制40个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="文本类型" prop="popoverType">
          <el-input
            style="width:300px"
            disabled
            v-model.trim="ruleForm.popoverType"
            maxlength="40"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="气泡文本外部内容" prop="popoverExtraContent">
          <hm-rich-editor
            v-model="ruleForm.popoverExtraContent"
            :html="ruleForm.popoverExtraContent"
          />
        </el-form-item>
        <el-form-item label="气泡文本内部内容" prop="popoverIntraContent">
          <hm-rich-editor
            v-model="ruleForm.popoverIntraContent"
            :html="ruleForm.popoverIntraContent"
          />
        </el-form-item>
      </el-form>
      <div class="dialog-footer flex flex-center">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="$router.back(-1)" size="small">返回</el-button>
      </div>
    </div>
  </hm-content>
</template>

<script>
import HmRichEditor from "@/components/HmRichEditor";
export default {
  components: {
    HmRichEditor
  },
  data() {
    return {
      type: this.$route.query.type,
      row: {},
      ruleForm: {
        popoverName: "",
        popoverCode: "",
        popoverType: "text",
        popoverExtraContent: "",
        popoverIntraContent: ""
      },
      rules: {
        popoverName: {
          required: true,
          trrger: "blur",
          message: "请输入文本名称"
        },
        popoverCode: {
          required: true,
          trrger: "blur",
          message: "请输入文本编码"
        },
        popoverType: {
          required: true,
          trrger: "blur",
          message: "请选择文本类型"
        },
        popoverExtraContent: {
          required: true,
          trrger: "blur",
          message: "请输入文本内容"
        },
        popoverIntraContent: {
          required: true,
          trrger: "blur",
          message: "请输入文本内容"
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.type === "edit") {
      this.row = JSON.parse(this.$route.query.row);
      for (let key in this.row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = this.row[key];
        }
      }
    }
  },
  methods: {
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        if (this.type === "edit") {
          params.id = this.row.id;
        }

        const { code } = await this.$store.dispatch(
          "addInterfacePopoverInfo",
          params
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.$router.back(-1);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
